import { OPEN_SESSION_TIMEOUT_MODAL, CLOSE_SESSION_TIMEOUT_MODAL } from './actionTypes';

export const openSessionTimeoutModal = () => ({
  type: OPEN_SESSION_TIMEOUT_MODAL,
});

export const closeSessionTimeoutModal = () => ({
  type: CLOSE_SESSION_TIMEOUT_MODAL,
});
